/* eslint-disable jsx-a11y/anchor-has-content */
import Lottie from "lottie-react";
import "./hero.css";
import devAnimation from "../../animation/dev.json";
import { useRef } from "react";
import { motion } from "framer-motion";

const Hero = () => {

  const lottieRef = useRef();
  const textArr = 'I’m Haidar Dalla,Front End Devoloper'.split('')
  const pVariants = {
    hidden: {
      opacity: 0,
    },
    visble: {
      opacity: 1,
      transition: {
        staggerChildren: .1
      }
    }
  }
  const spanVariants = {
    hidden: {
      opacity: 0,
    },
    visble: {
      opacity: 1
    }
  }
  return (
    <section className="hero flex" id="aboute">
      <div className="left-section  ">
        <div className="parent-avatar flex">
          <motion.img
            initial={{ transform: "scale(0)" }}
            animate={{ transform: "scale(1.1)" }}
            transition={{ damping: 6, type: "spring", stiffness: 100 }}
            src="./me.jpg"
            className="avatar"
            alt=""
          />
          <div className="icon-verified"></div>
        </div>

        <motion.h1
          variants={pVariants}
          initial={"hidden"}
          animate={"visble"}
          transition={{ delay: 4.2, duration: 1 }}
          className="title"
        >
          {textArr.map((e, i) => <motion.span variants={spanVariants} key={i + 1}>{e}</motion.span>)}
        </motion.h1>

        <p className="sub-title">
          I’m Haidar Dalla, Front End Devoloper ,Ihave meny expireans in HTML CSS JS and React
        </p>

        <div className="all-icons flex">
          <span><div className="icon icon-twitter"></div></span>
          <span><div className="icon icon-instagram"></div></span>
          <span><a className="icon icon-github" target="_blank" href="https://github.com/HaidarDalla" rel="noreferrer"></a></span>
          <span><div className="icon icon-linkedin"></div></span>
        </div>


        {/* Updated */}
        {/* <div className="links-animation d-f-c" >
          <div className="content d-f-c">
            <span className="tiktok"><a className="icon icon-github" target="_blank" href="https://github.com/HaidarDalla" rel="noreferrer"></a></span>
            <div className="box">
              <span className="twitter"><div className="icon icon-twitter"></div></span>
              <span className="cinter">Links   <i className="icon-arrow-right"></i></span>
              <span className="telegrame"><div className="icon icon-instagram"></div></span>
            </div>
            <span className="facebook"><div className="icon icon-linkedin"></div></span>

          </div>
        </div> */}
        {/* Updated */}

      </div>

      <div className="right-section animation ">
        <Lottie
          lottieRef={lottieRef}
          className=""
          onLoadedImages={() => {
            // @ts-ignore
            // https://lottiereact.com/
            lottieRef.current.setSpeed(0.5);
          }}
          animationData={devAnimation}
          style={{ width: '600px' }}
        />
      </div>
    </section>
  );
};

export default Hero;
